// Thin semantic-event layer. Pushes events to the GTM dataLayer; GTM forwards
// them to whichever tags (GA4, Meta Pixel, TikTok, Google Ads, …) are
// configured for that event. Safe to call anywhere — no-op during SSG / when
// GTM is absent.

interface DataLayerWindow {
  dataLayer: Record<string, unknown>[]
}

export function trackEvent(event: string, params: Record<string, unknown> = {}): void {
  if (typeof window === 'undefined') return
  const w = window as unknown as DataLayerWindow
  w.dataLayer = w.dataLayer || []
  w.dataLayer.push({ event, ...params })
}
